import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import PlanId                from "../../../domain/plan/PlanId";
import PlanRepository        from "../../../domain/plan/PlanRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import PlanDataSource        from "../../../infrastructure/datasource/plan/PlanDataSource";

class DeletePlan {
  constructor(
    private readonly dispatch,
    private readonly planRepository: PlanRepository = new PlanDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute(planId: PlanId) {
    try {
      this.fetchStatusRepository.start();
      await this.planRepository.delete(planId);
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeletePlan;
